$shm_hitalama_guide_page $mol_page
	help_section \
	head /
		<= Title
		<= Help $shm_hitalama_guide_toggle
			section <= help_section
		<= Tools
